// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/documents/local/actions';
import { checkExistance } from '../state/documents/actions';
import { getShapes } from '../state/domains/shapes/actions';
import { groupShapes } from '../state/domains/shapes/reducer';

// Components
import Local from '../components/Documents/Local';

function mapStateToProps(state) {
	// TODO, the projecs[0] might not work for 2 projetcs
	return {
		sectors: state.documents.current.sectors,
		localities: state.documents.current.localities,
		samplingPoints: state.documents.current.samplingPoints,
		points: state.documents.current.points,
		rects: state.documents.current.rects,
		shapes: state.domains.shapes.list,
		groupedShapes: groupShapes(state.domains.shapes.list, state.documents.current.projects[0].id)
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch),
		getShapes: bindActionCreators(getShapes, dispatch),
		checkExistance: bindActionCreators(checkExistance, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Local);


// WEBPACK FOOTER //
// ./src/containers/LocalContainer.js